var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8FinancialGrowthAnalysis1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.66663C7.44263 2.66663 2.66663 7.44263 2.66663 13.3333C2.66663 19.224 7.44263 24 13.3333 24C19.224 24 24 19.224 24 13.3333C24 7.44263 19.224 2.66663 13.3333 2.66663Z",
    fill: "#FFDD64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1567 19.3286C21.4 20.4399 20.4393 21.4006 19.328 22.1573L26.9187 29.7479L29.7473 26.9193L22.1567 19.3286Z",
    fill: "#FB348C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10.6666H22.6666V13.3333H28V10.6666Z",
    fill: "#FB348C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.026 10.6667L16.154 13.006L12.148 6.35669L7.30396 12H2.74929C2.69463 12.4367 2.66663 12.882 2.66663 13.3334C2.66663 13.7847 2.69463 14.23 2.74929 14.6667H8.52929L11.768 10.8934L15.8453 17.6607L19.3073 13.3334H24C24 12.4127 23.8833 11.5194 23.664 10.6667H18.026Z",
    fill: "#D72573"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FinancialGrowthAnalysis1);
export default __webpack_public_path__ + "static/media/icons8-financial-growth-analysis-1.233e5b380123956514eccfece476172c.svg";
export { ForwardRef as ReactComponent };